var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#A6EEFA;}\n\t.st2{fill:#0181A1;}\n\t.st3{fill:#003057;}\n\t.st4{fill:#01496E;}\n\t.st5{fill:#007694;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 180,
    height: 180
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 180,
    height: 180
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.8,110.1c0,0,0.2,19.8,2.9,21.8c1.6,1.2,5.9,3.5,9.2,5.2c2.1,1.1,3.8,2,3.8,2s-41.8,33.5-74.3-1.1 l6.5-4.1c0,0,3.5-3.7,3.2-9.2c-0.3-5.6-0.3-14.6-0.3-14.6H113.8L113.8,110.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58,83c0,0-4.7-12.2-5.9-14.2c-1.2-1.9,0.9-8.6,0-10C51.3,57.5,51,37.2,58,31.1c7-6.1,11.1-7.8,11.1-7.8 s0.3-2.5,6.7-2.5c6.5,0,1-4.2,11.5-2.5c10.6,1.7,12.6,1.7,12.6,1.7l2.3-0.3c0,0,8.5,3.3,7.9,6.9s8.5,0,8.5,0v2.5 c0,0,7.6,0.3,7.6,19.4c0,18.5-1.4,25-3.5,26.1c-2.1,1.1-4.4,5-4.4,5S97.7,94.3,58,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.4,133.6c0,0,9.1,13,26.8,13c24.9,0,30.2-11.8,30.2-11.8l1.1-1.7c0,0,47.1,13.5,51.1,31.9 c44.4,204.2-186,156.4-160.5,0C13,146.6,55.8,135.2,61.4,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117,132.1c-0.1-0.1-0.2-0.2-0.3-0.2c-2.7-1.9-2.9-21.8-2.9-21.8H64.7c0,0,0,5.8,0.1,10 C80.7,142,105.4,132.4,117,132.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.7,95.3c0,0-0.3,16.4,15,26.1C87.9,131,100,123,100,123s16.1-11.9,16.4-18.3c0.3-6.4,2.7-9.4,2.7-9.4 s1.8,0,2.9-1.4c1.2-1.4,1.5-10.3,2.3-12.8c0.9-2.5,1.5-6.7-1.5-6.4c-2.9,0.3-4.4,5-4.4,5s0.6-7.8-1.2-12.8 c-1.8-5,1.5-16.1-5.6-20.3c-7-4.2-16-2.8-20.3-1.4c-4.3,1.4-13.4,0.5-19-1.4c-5.6-1.9-10.3,7.2-11.2,11.4s-3.8,21.1-3.5,24.4 c0.3,3.3,0.3,3.3,0.3,3.3s-2-8.9-3.8-9.4c-1.8-0.5-5-0.5-4.4,6.1c0.6,6.7,1.3,1.5,3.8,13.9C55,100.8,57.7,95.3,57.7,95.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.ec409b5cac4ce04b81923e889d17efa8.svg";
export { ForwardRef as ReactComponent };